import { DashboardFilters, timeRanges } from '@/services/dashboard-service/dashboard.service.types';
import styles from './call-metric-filters.module.scss';
import { Flex } from 'antd';
import { Button } from '@/components/button/button';

interface CallMetricFiltersProps {
  onChange: (value: DashboardFilters) => void;
  value: DashboardFilters;
}

export const CallMetricFilters = ({ onChange, value }: CallMetricFiltersProps) => {
  return (
    <Flex gap={4} className={styles.container}>
      {timeRanges.map((filter) => {
        return (
          <Button
            buttonVariant="secondary"
            key={filter}
            className={value.time_range === filter ? styles.active : ''}
            onClick={() => onChange({ ...value, time_range: filter })}
          >
            {filter}
          </Button>
        );
      })}
    </Flex>
  );
};
